/// <amd-module name="TFS/Samples/PeoplePicker/PeoplePicker" />
import * as React from "react";

import { Components, IVssComponentContext, VssComponent } from "VSS/Platform/Layout";

import { ObservableArray, ObservableValue } from "VSS/Core/Observable";
import { PeoplePickerProvider } from "VSS/Features/Identities/IdentityPickerProvider";
import { PersonaDetailsProvider } from "VSS/Features/Identities/PersonaDetailsProvider";
import { IdentityPicker, IdentityPickerDropdown, IIdentity, IPeoplePickerProvider } from "VSSUI/IdentityPicker";
import { Observer } from "VSSUI/Observer";
import { Persona, PersonaSize } from "VSSUI/Persona";

interface PeoplePickerProps {}

export class PeoplePickerPage extends VssComponent<PeoplePickerProps> {
    private personaDetailsProvider: PersonaDetailsProvider;
    private pickerProvider: IPeoplePickerProvider;
    private selectedIdentity: ObservableValue<IIdentity | undefined> = new ObservableValue<IIdentity | undefined>(undefined);
    private selectedItems: ObservableArray<IIdentity> = new ObservableArray<IIdentity>([]);
    public displayName: string;

    constructor(props: PeoplePickerProps, context: IVssComponentContext) {
        super(props, context);
        this.pickerProvider = new PeoplePickerProvider(this.context.pageContext, {
            identityTypes: ["user", "group"],
            options: {
                MinResults: 5,
                MaxResults: 20
            }
        });
        this.personaDetailsProvider = new PersonaDetailsProvider(this.context.pageContext);
    }

    public render(): JSX.Element {
        return (
            <div className="flex-row">
                <div className="flex-column" style={{ margin: "10px" }}>
                    <Observer selectedIdentity={this.selectedIdentity}>
                        {(props: { selectedIdentity: IIdentity | undefined }) => {
                            if (!props.selectedIdentity) {
                                return <div />;
                            }
                            return (
                                <>
                                    <Persona
                                        identity={props.selectedIdentity}
                                        size={PersonaSize.size16}
                                        personaProvider={this.personaDetailsProvider}
                                    />
                                    <Persona
                                        identity={props.selectedIdentity}
                                        size={PersonaSize.size20}
                                        personaProvider={this.personaDetailsProvider}
                                    />
                                    <Persona
                                        identity={props.selectedIdentity}
                                        size={PersonaSize.size24}
                                        personaProvider={this.personaDetailsProvider}
                                    />
                                    <Persona
                                        identity={props.selectedIdentity}
                                        size={PersonaSize.size32}
                                        personaProvider={this.personaDetailsProvider}
                                    />
                                    <Persona
                                        identity={props.selectedIdentity}
                                        size={PersonaSize.size40}
                                        personaProvider={this.personaDetailsProvider}
                                    />
                                    <Persona
                                        identity={{
                                            displayName: props.selectedIdentity.displayName || "",
                                            id: props.selectedIdentity.entityId,
                                            imageUrl: props.selectedIdentity.image || ""
                                        }}
                                        size={PersonaSize.size72}
                                        personaProvider={this.personaDetailsProvider}
                                    />
                                </>
                            );
                        }}
                    </Observer>
                </div>
                <div className="flex-column" style={{ width: "300px", margin: "10px" }}>
                    <IdentityPickerDropdown pickerProvider={this.pickerProvider} onChange={this.onPersonChange} value={this.selectedIdentity} />
                </div>
                <div className="flex-column" style={{ width: "750px", margin: "10px" }}>
                    <IdentityPicker
                        selectedIdentities={this.selectedItems}
                        onResolveEntity={this.resolveEmail}
                        onIdentityAdded={this.onTagAdded}
                        onIdentityRemoved={this.onTagRemoved}
                        onIdentitiesRemoved={this.onTagsRemoved}
                        pickerProvider={this.pickerProvider}
                    />
                </div>
            </div>
        );
    }
    private resolveEmail = (email: string, item: IIdentity | null): void => {
        if (item) {
            this.selectedItems.change(this.selectedItems.value.findIndex(identity => identity.entityId === email), item);
        } else {
            this.selectedItems.removeAll(identity => identity.entityId === email);
        }
    };

    private onTagAdded = (item: IIdentity): void => {
        console.log(item.entityId);
        this.selectedItems.push(item);
    };

    private onTagRemoved = (item: IIdentity): void => {
        console.log(item.entityId);
        this.selectedItems.value = this.selectedItems.value.filter(entity => entity.entityId !== item.entityId);
    };

    private onTagsRemoved = (items: IIdentity[]): void => {
        console.log(items.map(item => item.entityId).join(", "));
        this.selectedItems.value = this.selectedItems.value.filter(entity => items.filter(item => item.entityId === entity.entityId).length === 0);
    };

    private onPersonChange = (item?: IIdentity): boolean => {
        if (item) {
            console.log(item.entityId);
        } else {
            console.log("identity has been cleared");
        }
        this.selectedIdentity.value = item;

        return true;
    };
}

Components.add("people-picker-page", PeoplePickerPage);
